import { render } from "./MockAdminDemo.vue?vue&type=template&id=2c7d1946&scoped=true"
import script from "./MockAdminDemo.vue?vue&type=script&lang=js"
export * from "./MockAdminDemo.vue?vue&type=script&lang=js"

import "./MockAdminDemo.vue?vue&type=style&index=0&id=2c7d1946&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7d1946"]])

export default __exports__